import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'

const data = {
  question:
    'Which of the following is an example of how you can control which ads you see on social media?',
  inputType: 'checkbox',
  options: [
    {
      label: '“Hide” or “Report” unwanted vaping ads.',
    },
    {
      label: '“Follow” influencers that promote vaping.',
    },
    {
      label: '“Mute” or “Unfollow” vaping ads.',
    },
    {
      label: '“Repost” pictures of teens who vape.',
    },
    {
      label: '“Interact” with posts about vaping',
    },
  ],
}

const correctInput = {
  [data.question]: [data.options[0].label, data.options[2].label],
}

const feedback = {
  success: {
    title: 'That’s right!',
    body:
      'When social media feeds are filled with dangerous, unhealthy, or unsafe advertisements, you can “hide,” “report,” “mute,” and “unfollow” them.',
  },
  error: {
    title: 'Not quite.',
    body:
      'When social media feeds are filled with dangerous, unhealthy, or unsafe advertisements, you can “hide,” “report,” “mute,” and “unfollow” them. You will learn more about this in the module.',
  },
}

export default {
  title: 'Question 2',
  path: '/prepare/question-2',
  content: (
    <Fragment>
      <Intro
        title="Question 2"
        direction={'Select the two items that best complete the statement.'}
      />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Prepare/Question2.js